export class JsActionApi {
  get EdsApi() {
    return this.#getEdsApi()
  }
  
  get QrCodeApi() {
    return this.#getQrCodeApi()
  }

  #getEdsApi = null
  #getQrCodeApi = null

  constructor(dependencies) {
    const { 
      store,
      GraphqQlApi, 
      Moment, 
      MomentDuaration,
      SignalRApi, 
      NotificationApi, 
      ProcessingApi, 
      getEdsApi, 
      getQrCodeApi,
      axios, 
      RouterCore, 
      DataSourceCore,
      $t,
      $microflowRunner
    } = dependencies
    this.#getEdsApi = getEdsApi
    this.#getQrCodeApi = getQrCodeApi

    this.store = store
    this.GraphqQlApi = GraphqQlApi
    this.$t = $t
    this.Moment = Moment
    this.MomentDuaration = MomentDuaration
    this.SignalRApi = SignalRApi
    this.NotificationApi = NotificationApi
    this.ProcessingApi = ProcessingApi
    this.Axios = axios
    this.RouterCore = RouterCore
    this.DataSourceCore = DataSourceCore
    this.$microflowRunner = $microflowRunner
    this.JsActionApi = function () {
      return new JsActionApi(dependencies)
    }
  }
  async call(id, parameters) {
    let JSActions = this.store.state.appRunner.model.Modules.DefaultModuleImpl.JSActions
    if (!JSActions || JSActions.length == 0) {
      return null
    }
    const currentJsAction = JSActions.find(el => el.$ID == id)
    if (!currentJsAction) {
      console.error(`JSAction with id ${id} not found`)
      return null
    }

    try {
      let callJsActionMethod = new Function('parameters', currentJsAction.Text)
      return callJsActionMethod.call(this, parameters)
    } catch (e) {
      console.error(`In JSAction ${id} detected syntactic error`)
      return null
    }
  }
}